import { useEffect, useState } from "react";
import { apiClient, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const FIELDS = [
  { key: "instagram_url", label: "Instagram URL", placeholder: "https://instagram.com/yourhandle" },
  { key: "facebook_url", label: "Facebook URL", placeholder: "https://facebook.com/yourpage" },
  { key: "linkedin_url", label: "LinkedIn URL", placeholder: "https://linkedin.com/company/yourcompany" },
];

export const SocialLinksManager = () => {
  const [form, setForm] = useState({ instagram_url: "", facebook_url: "", linkedin_url: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiClient
      .get("/settings")
      .then(({ data }) => {
        setForm({
          instagram_url: data.instagram_url || "",
          facebook_url: data.facebook_url || "",
          linkedin_url: data.linkedin_url || "",
        });
      })
      .finally(() => setLoading(false));
  }, []);

  const setField = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  const handleSave = async () => {
    setSaving(true);
    try {
      await apiClient.put("/admin/settings", form);
      toast.success("Social links updated");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not save social links");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="text-[#A1B0A6] text-sm">Loading...</p>;

  return (
    <div data-testid="admin-social-links-manager" className="max-w-xl">
      <p className="text-sm text-[#A1B0A6] mb-6">
        Add your social media page links. Buttons appear in the site footer automatically once a
        link is saved here — leave a field blank to hide that button.
      </p>
      <div className="space-y-4">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <label className="text-xs text-[#6E7E74] uppercase tracking-wide mb-1.5 block">
              {f.label}
            </label>
            <input
              value={form[f.key]}
              onChange={(e) => setField(f.key, e.target.value)}
              placeholder={f.placeholder}
              data-testid={`admin-social-input-${f.key.replace("_url", "")}`}
              className="w-full bg-deep-card border border-gold/15 rounded-md px-3 py-2 text-sm text-[#F4F7F5] placeholder:text-[#6E7E74] focus:outline-none focus:border-gold/50"
            />
          </div>
        ))}
      </div>
      <button
        onClick={handleSave}
        disabled={saving}
        data-testid="admin-social-save-btn"
        className="mt-6 bg-gold hover:bg-gold-hover disabled:opacity-50 text-[#0A140F] text-sm font-display font-semibold px-5 py-2 rounded-md transition-colors"
      >
        {saving ? "Saving..." : "Save Social Links"}
      </button>
    </div>
  );
};
